import { Canvg } from "canvg";
import chroma from "chroma-js";
import { saveAs } from "file-saver";

const downloadPaletteImage = (colorPalette, nameImage = "Paleta de color") => {
  if (typeof window === "undefined" || colorPalette.length !== 5) {
    return { downloadPng: () => {}, downloadSvg: () => {} };
  }

  const canv = document.createElement("canvas");
  canv.id = "canv";
  const ctx = canv.getContext("2d");

  let svgStore = "";

  const makeRects = () => {
    let rects = "";
    let xPosition = 0;

    for (let i = 0; i < colorPalette.length; i++) {
      rects += `
      <rect
        x="0"
        y="${xPosition}%"
        width="100%"
        height="20%"
        opacity="1"
        fill="${colorPalette[i]}"
      />

      <text x="5%" y="${xPosition + 10}%"
       style="font-family: Times New Roman;
        font-size : 44;
        fill       : ${
          chroma(colorPalette[i]).luminance() < 0.5 ? "#fff" : "#505050"
        };"
        >
      ${colorPalette[i]} 
      </text>
    `;
      xPosition = xPosition + 20;
    }

    return rects;
  };

  const makeSVG = () => {
    const w = 1000;
    const h = 1500;
    const svg = `<svg width="${w}" height="${h}" id="svg" xmlns="http://www.w3.org/2000/svg">
  <text x="2%" y="95%"
    font-family="Verdana"
    font-size="20"
    style="font-family: Times New Roman;
    font-size  : 26;
    fill       : #000;
    "
    >
    https://paletadecolores.online
  </text>
    <rect x="0" y="0" width="${w}" height="${h}" fill="#fff" fill-opacity="1"/>

    ${makeRects()}
  </svg>`;

    svgStore = svg;
    return svg;
  };

  const setup = () => {
    const svg = makeSVG();
    const v = Canvg.fromString(ctx, svg);
    v.start();
  };

  setup();

  const download = (filename, text) => {
    const pom = document.createElement("a");
    pom.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    pom.setAttribute("download", filename);

    if (document.createEvent) {
      const event = document.createEvent("MouseEvents");
      event.initEvent("click", true, true);
      pom.dispatchEvent(event);
    } else {
      pom.click();
    }
  };

  const downloadSvg = () => download("palette.svg", svgStore);

  const downloadPng = () => {
    canv.toBlob(blob => {
      if (blob) {
        saveAs(blob, `${nameImage}.png`);
      }
    });
  };

  return { downloadPng, downloadSvg };
};

export default downloadPaletteImage;
